import { FC, MouseEvent } from 'react'
import { StyledIconButton } from './PlanTableProductCell.styles'
import AddIcon from '@/core/assets/icons/add.svg'
import { Product } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { ProductCellMoreMenu } from './ProductCellMoreMenu'
import ProductCard from '../../../../../components/ProductCard/ProductCard.tsx'
import { useAddProductToPlan } from '@/data/replenishmentPlan/hooks/useAddProductToPlan.ts'
import { useTrackReplenishmentPlanAnalyticsEvent } from '@/core/hooks/useTrackReplenishmentPlanAnalyticsEvent.ts'
import {
  DatagridActionsEvent,
  DatagridActionsType,
} from '@/core/analytics/events/replenishmentPlan/DatagridActionsEvent.ts'

interface Props {
  product: Product
}

const PlanTableProductCell: FC<Props> = ({ product }) => {
  const { addProductToPlan, isLoading } = useAddProductToPlan()

  const { trackReplenishmentPlanAnalyticsEvent } =
    useTrackReplenishmentPlanAnalyticsEvent()

  const onAddToPlan = async () => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridActionsEvent({
        type: DatagridActionsType.AddToPlan,
      }),
    )

    await addProductToPlan(product)
  }

  const onActionsClick = (event: MouseEvent) => {
    // Prevent click on actions from triggering row click
    // We will have here a link to product details in the future
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <ProductCard
      product={product}
      actions={
        <div onClick={onActionsClick}>
          {product.isInPlan ? (
            <ProductCellMoreMenu product={product} />
          ) : (
            <StyledIconButton
              size="small"
              disabled={isLoading}
              onClick={onAddToPlan}
            >
              <AddIcon />
            </StyledIconButton>
          )}
        </div>
      }
    />
  )
}

export default PlanTableProductCell
